import {
  addParamToURL,
} from './url-utils';
import {
  SOURCE_QUERY_PARAM_NAME,
  AUTH_TOKEN_QUERY_PARAM_NAME,
  NZ_DOMAIN,
  AUS_DOMAIN,
  BACKEND_ROOT_KEY,
  GATEWAY_EXT_ROOT_KEY,
} from '../constants';

const {
  REACT_APP_IP_LOCATION_CHECK_ENABLED,
  REACT_APP_BACKEND_ROOT,
  REACT_APP_BACKEND_ROOT_AUS,
  REACT_APP_BACKEND_ROOT_NZ,
  REACT_APP_GATEWAY_EXT_ROOT,
} = process.env;

export const determineDataUrls = () => {
  let backendRoot = REACT_APP_BACKEND_ROOT;
  if (window.origin.includes(NZ_DOMAIN)) {
    backendRoot = REACT_APP_BACKEND_ROOT_NZ;
  } else if (window.origin.includes(AUS_DOMAIN)) {
    backendRoot = REACT_APP_BACKEND_ROOT_AUS;
  }
  return {
    [BACKEND_ROOT_KEY]: backendRoot,
    [GATEWAY_EXT_ROOT_KEY]: REACT_APP_GATEWAY_EXT_ROOT,
  };
};

export const handleSiteRedirect = (url, source, authToken) => {
  if (!url) {
    return;
  }
  let redirectUrl = url;
  redirectUrl = addParamToURL(redirectUrl, AUTH_TOKEN_QUERY_PARAM_NAME, authToken);
  redirectUrl = addParamToURL(redirectUrl, SOURCE_QUERY_PARAM_NAME, source);
  window.location.replace(redirectUrl);
  // Can't clear the analytics user here because queue may still be active
};

export const isIpLocationEnabled = () => REACT_APP_IP_LOCATION_CHECK_ENABLED === 'true';
